export default "/_next/static/images/img2-dac493baeff758bb2f2d26da13da7e48.png";